export default __webpack_public_path__ + "static/media/about-img2.268c3b4d.png";